import { IconAlertTriangle, IconInfoCircle } from '@tabler/icons-react';
import type { ReactNode } from 'react';

type Props = { tone?: 'info' | 'warning' | 'error'; children: ReactNode; action?: ReactNode };

export function Banner({ tone = 'info', children, action }: Props) {
  const Icon = tone === 'info' ? IconInfoCircle : IconAlertTriangle;
  return (
    <div className={`banner banner--${tone}`} role={tone === 'error' ? 'alert' : 'status'}>
      <Icon size={20} />
      <div className="grow">{children}</div>
      {action}
    </div>
  );
}
